(function () {
  angular.module("akitabox.planView.dialogs.legacy-fac-filter", [
    "ngMaterial",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.alert",
  ]);
})();
